import { LinkedIn as LinkedInIcon } from "@mui/icons-material";
import { IconButton, Link } from "@mui/material";

interface PersonLinksProps {
	href: string;
}

export const PersonLinks = ({ href }: PersonLinksProps) => {
	return (
		<IconButton
			target="_blank"
			size="small"
			component={Link}
			href={href}
			data-component="linkedin-link"
		>
			<LinkedInIcon />
		</IconButton>
	);
};
